import GET_ALL_CUSTOMERS from "../graphql/allCustomers.gql";
import { apolloClient } from "./apollo";
import ADDRESS_FORM from "../graphql/addressForm.gql";
/**
 * This is only mock api
 *
 */
export const CUSTOMERS = GET_ALL_CUSTOMERS;
export function getCustomers(serviceman= '', cardCode = '') {
    return apolloClient.mutate({
        fetchPolicy: "no-cache",
        mutation: GET_ALL_CUSTOMERS,
        variables: {
            serviceman: (serviceman) ? serviceman : "",
            cardCode: (cardCode) ? cardCode : ""
        },
        update: (cache, { data: { customerByUser } }) => {
            console.log(customerByUser);
        },
    })
}
export function setAddressForm(form, cardCode, customerId){
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({

        mutation: ADDRESS_FORM,
        fetchPolicy: "no-cache",
        variables: {
            customerId: customerId,
            addressId: (form.addressId) ? form.addressId : '',
            addressName: form.addressName,
            city: form.city,
            street: form.street,
            postCode: form.postcode,
            country: form.country,
            cardCode: cardCode,
            personName: form.personName,
            personEmail: form.personEmail,
            personPhone: form.personPhone
        }
    })
}

export function addAddressForm(form){
    if(!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: ADDRESS_FORM,
        fetchPolicy: "no-cache",
        variables: {
            addressName: form.addressName,
            city: form.city,
            street: form.street,
            postCode: form.postCode,
            cardCode: ""
        }
    })
}
